import React, {useState} from "react"
import Checkbox from "./checkbox"

export default function CheckboxGroup({json, dependencies, onFieldChange})
{  
    const [field , setField] = useState('')    

    const setFieldValue = (value, action) =>
    {
        const values = field === '' ? [] : field.split(',')

        switch(action)
        {
            case 'add': 
                values.push(value.toString())
                break

            case 'remove':
                const index = values.indexOf(value.toString())

                console.log(index)

                if (index > -1) values.splice(index, 1)
                break
        }

        setField(values.join(','))
        if(dependencies) dependencies(json.key, field)
        if(onFieldChange) onFieldChange(json.key, field)
    }
    
    return (
        <div className="json-input">
            {json.label && <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} /> }
            <input className={'input_'+json.key} type="hidden" name={json.key} value={field} />
            <div className="stylized-checkbox-group">
            {                                        
                json.options.map(option =>
                    {
                        return(
                            <Checkbox name={json.key} value={option[0]} label={option[1]} onChange={setFieldValue} />
                        )
                    })  
            }
            </div>
        </div>                 
    )
}